import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useInvalidateCache } from "~hooks/useInvalidateCache.ts";
import type { CreateEntity } from "~pages/Entities/types/upsertEntity.ts";
import type { Entity, EntityResponse } from "~types/entity.ts";

export const useCreateEntity = () => {
  const { sport, organizationId } = useParams();
  const queryClient = useQueryClient();
  const request = useApi();
  const { mutateAsync: invalidateCache } = useInvalidateCache();

  return useMutation<Entity, Error, CreateEntity>({
    mutationFn: async (data) => {
      const response = await request<EntityResponse>(`${sport}/o/${organizationId}/entities`, {
        method: "POST",
        body: data,
      });

      return response?.data?.[0];
    },
    onSuccess: async () => {
      await Promise.all([invalidateCache(), queryClient.invalidateQueries({ queryKey: ["entities", sport, organizationId] })]);
    },
  });
};
